module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 021.bb5e8d4c.jpg";